import { List, Map, Record } from "immutable";
import _ from "lodash";

export const positionToKeyPath = position => _.flatten(position.map(p => ["children", p - 1]));
export const keyPathToPosition = keyPath => _.without(keyPath, "children").map(i => i + 1);

export const findKeyPathOfNode = (tree, searchId) => {
  const predicate = node => node === searchId || node.id === searchId;
  let path;
  if (List.isList(tree)) {
    tree.some(function(child, i) {
      path = findKeyPathOfNode(child, searchId);
      if (path) return path.unshift(i); // always returns truthy
    });
    return path;
  }
  if (predicate(tree)) {
    return [];
  }
  if (Record.isRecord(tree) && tree.has("children")) {
    path = findKeyPathOfNode(tree.get("children"), searchId);
    if (path) return ["children"].concat(path);
  }
};

export const findItemPosition = (tree, itemId) => keyPathToPosition(findKeyPathOfNode(tree, itemId));

const getPositionsFromTree = (subtree, position, result) => {
  subtree.children.map((c, i) => {
    let p = _.clone(position);
    p.push(i + 1);
    if (_.isString(c)) {
      result[c] = p;
    } else {
      if (c.id) {
        result[c.id] = p;
      }
      getPositionsFromTree(c, p, result);
    }
  });
};

export const narrativePositionsForIds = tree => {
  let result = {};
  getPositionsFromTree(tree, [], result);
  return Map(result);
};
